/**
 * Шапка «Задачника» на телефоне: выбор отдела и доски с кнопками действий
 * и фильтры свёрнуты под две кнопки.
 *
 * Развёрнутыми они занимали полэкрана, и на канбан оставалась полоска.
 * Свёрнутая кнопка подписана отделом и доской — понятно, где находишься,
 * а счётчик на «Фильтрах» не даёт забыть, почему доска полупустая.
 */

import { ChevronDown, ChevronUp, SlidersHorizontal } from "lucide-react";
import { type ReactNode, useId, useState } from "react";

import { Button } from "@/shared/ui";

export function PhoneTaskbookBar({
  title,
  activeFilters,
  header,
  filters,
}: {
  /** Подпись свёрнутой шапки: отдел и доска. */
  title: string;
  activeFilters: number;
  header: ReactNode;
  filters: ReactNode;
}) {
  const [headerOpen, setHeaderOpen] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const headerId = useId();
  const filtersId = useId();

  return (
    <>
      <div className="flex shrink-0 items-center gap-2 border-b border-line bg-surface px-4 py-2">
        <Button
          variant="secondary"
          size="sm"
          iconRight={headerOpen ? ChevronUp : ChevronDown}
          aria-expanded={headerOpen}
          aria-controls={headerId}
          title="Отдел, доска и действия"
          className="min-w-0 flex-1 justify-between gap-2"
          onClick={() => setHeaderOpen((value) => !value)}
        >
          <span className="truncate">{title}</span>
        </Button>
        <Button
          variant={activeFilters > 0 ? "primary" : "secondary"}
          size="sm"
          icon={SlidersHorizontal}
          aria-expanded={filtersOpen}
          aria-controls={filtersId}
          aria-label={
            activeFilters > 0 ? `Фильтры, включено: ${String(activeFilters)}` : "Фильтры"
          }
          className="gap-1.5"
          onClick={() => setFiltersOpen((value) => !value)}
        >
          {activeFilters > 0 ? `Фильтры · ${String(activeFilters)}` : "Фильтры"}
        </Button>
      </div>

      {headerOpen && (
        <div id={headerId} className="shrink-0">
          {header}
        </div>
      )}

      {/* Фильтров много: развёрнутые, они прокручиваются сами, а не
          выдавливают доску за край экрана. */}
      {filtersOpen && (
        <div id={filtersId} className="max-h-[55dvh] shrink-0 overflow-y-auto">
          {filters}
        </div>
      )}
    </>
  );
}
